module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loadmsg":"Loading Data......"},"cn":{"loadmsg":"正在加载数据"}}')
  delete Component.options._Ctor
}
